import { SettingKey } from 'src/constants';
import yup from 'src/libraries/validator.library';
import {
  ISettingForm,
  SettingListSchema,
  SettingPayloadSchema,
} from 'src/models/setting.model';
import { httpClient } from 'src/libraries/http.library';

const client = httpClient();

const services = {
  listGET: async () => {
    return client.get('configSettings', { limit: 0 }, SettingListSchema);
  },
  updatePUT: async (id: number, data: ISettingForm) => {
    return client.put(`configSettings/${id}`, data, SettingPayloadSchema);
  },
  addPOST: async (data: ISettingForm) => {
    return client.post('configSettings', data, SettingPayloadSchema);
  },
  itemDELETE: async (id: number) => {
    return client.delete(`configSettings/${id}`, yup.mixed());
  },

  findByKeyGET: async (key: SettingKey) => {
    return client.get(
      '/configSettings',
      {
        key,
      },
      SettingPayloadSchema
    );
  },
};

export default services;
